import { render, staticRenderFns } from "./bookingdetails.vue?vue&type=template&id=e6e1b224&"
import script from "./bookingdetails.vue?vue&type=script&lang=js&"
export * from "./bookingdetails.vue?vue&type=script&lang=js&"
import style0 from "./bookingdetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports